<template>
  <div>
    <BookingAvailabilityAlert v-if="booking_availability && !booking_availability.status"
      :booking_availability="booking_availability">
    </BookingAvailabilityAlert>
    <v-container class="pt-0 pb-5" v-if="show_cart">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <div class="d-flex justify-start" v-if="!show_payment_form">
              <p>
                <v-btn color="primary-dark" @click="$router.go(-1)" block class="sm-fullwidth mt-2" variant="default"
                  size="small"> <v-icon icon="mdi-arrow-left-bold" class="mr-1"></v-icon> Retour </v-btn>
              </p>
            </div>
            <v-divider></v-divider>
            <h4 class="font-weight-bold my-3"><v-icon icon="mdi-file-document-edit-outline" color="primary"
                size="xs-small"></v-icon> {{ account_wording[0] }} Sportips</h4>
            <div v-if="mainStore.authUser.isLogged">Connecté en tant que {{ mainStore.authUser.userMail }}</div>
            <v-row v-else>
              <v-col md="6" cols="12">
                <LoginForm></LoginForm>
              </v-col>
            </v-row>

            <v-divider></v-divider>
            <h4 class="font-weight-bold my-3"><v-icon icon="mdi-file-document-edit-outline" color="primary"
                size="xs-small"></v-icon> Récapitulatif de ma commande</h4>
            <v-row>
              <v-col cols="12" md="5" v-if="!show_payment_form">
                <div class="d-flex flex-column align-start justify-stretch rounded bg-dark pa-4 mt-2">
                  <div class="d-flex justify-space-between w-100">
                    <div>Nombre de participants</div>
                    <div>
                      {{ bookingStore.inscriptions.length }}
                    </div>
                  </div>
                  <div class="d-flex justify-space-between w-100" v-if="!bookingStore.exclude_taxe">
                    <div>Sous Total</div>
                    <div v-if="bookingStore.prix > 0">{{ bookingStore.prix }}€</div>
                  </div>
                  <div class="d-flex justify-space-between w-100" v-if="bookingStore.exclude_taxe">
                    <div>Frais de gestion</div>
                    <div>{{ bookingStore.taxe }}€</div>
                  </div>
                  <div class="d-flex justify-space-between w-100">
                    <div>Total à payer</div>
                    <div>{{ bookingStore.prix_total }}€</div>
                  </div>

                  <div class="w-100" v-if="mainStore.authUser.isLogged">
                    <BeforeAccessCheckout @onFreeCheckout="handle_free_checkout()"
                      @onAccessCheckout="access_checkout()">
                    </BeforeAccessCheckout>
                  </div>
                  <div class="mt-4" v-else>
                    <v-alert>Vous devez vous connecter à votre {{ account_wording[1] }} Sportips via le formulaire
                      ci-dessus afin
                      d'accèder au paiement et valider votre inscription.</v-alert>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="5" v-else>
                <AfterAccessCheckout></AfterAccessCheckout>
              </v-col>
              <v-col cols="12" md="7" v-if="!show_payment_form">
                <RecapitulatifCommande></RecapitulatifCommande>
              </v-col>
            </v-row>
            <div class="d-flex justify-center mt-3"></div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import LoginForm from "@/components/Authentification/LoginForm.vue";
import BeforeAccessCheckout from "@/components/FicheCoureur/ChangementParcours/Before_Access_Checkout.vue";
import AfterAccessCheckout from "@/components/FicheCoureur/ChangementParcours/After_Access_Checkout.vue";
import RecapitulatifCommande from "@/components/Checkout/Recapitulatif_Commande.vue";
import BookingAvailabilityAlert from "@/components/Checkout/Booking_Availability_Alert.vue";

export default {
  components: { LoginForm, BeforeAccessCheckout, AfterAccessCheckout, RecapitulatifCommande, BookingAvailabilityAlert },
  data() {
    return {
      show_payment_form: false,
      booking_validation: true,
      booking_availability: { status: true, errors: [] },
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
    account_wording() {
      const is_bicentenaire = this.mainStore.module.is_BICENTENAIRE26_module;
      if (is_bicentenaire) {
        return ["Mon espace personnel", "espace personnel"];
      } else {
        return ["Mon compte", "compte"];
      }
    },
    show_cart() {
      return this.booking_availability && this.booking_availability.status;
    }
  },
  methods: {
    async handle_free_checkout() {
      const check_availabilities = await this.bookingStore.check_availabilities();
      if (!check_availabilities.status && !this.mainStore.inscription_as_admin && !this.mainStore.inscription_vip && !this.mainStore.bookingSystem?.groupe?.inscription_course_complete) {
        this.booking_availability = check_availabilities;
        return;
      }
      const post_request = await this.bookingStore.post_free_change_parcours_checkout();
      if (post_request) {
        this.$router.push({ name: "CheckoutSuccess" });
      }

    },
    async access_checkout() {
      const request = await this.bookingStore.show_payment_form();
      this.show_payment_form = request.status;
      if (!request.status) {
        this.booking_availability = request;
      }
    },
  },
  async created() {
    if (!this.bookingStore.isInitialized) {
      this.$router.push({ name: "Home" });
    }
    this.bookingStore.compute_cart();
    this.booking_validation = this.bookingStore.get_validation();
  },
};
</script>

<style lang="scss" scoped>
.logo_paiement {
  width: 150px;
  max-width: 100%;
  height: auto;
}
</style>